import InputTypes from '../../../enums/InputTypes';
import { arrayToDate } from '../../../utils/DateMixins';

export default class ReceivedMapper {
    #getInputs(fields) {
        const listFields = fields.filter((el) => el?.form?.use);
        const inputs = [];
        for (let i = 0; i < listFields.length; i++) {
            const field = listFields[i];
            const nameUse = field?.form?.nameUse ?? field?.name;
            inputs.push({
                nameField: field?.name,
                nameUse: nameUse,
                type: field?.type,
                form: field?.form,
            });
        }
        return inputs;
    }

    format(value, input) {
        let nValue = value;
        switch (input.type) {
            case InputTypes.DATE:
                if (Array.isArray(nValue)) {
                    nValue = arrayToDate(nValue, nValue.length !== 3);
                }
                break;
            default:
                nValue = value;
                break;
        }
        return nValue;
    }

    async prepare(data, formController) {
        let inputs = this.#getInputs(formController.inputs);
        let retorno = {};

        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            retorno[input.nameField] =
                eval(
                    `data.${input.nameUse ?? input.nameField}`
                        .replaceAll('?.', '.')
                        .replaceAll('.', '?.')
                ) ?? '';
            retorno[input.nameField] = this.format(retorno[input.nameField], input);
        }
        return { ...data, ...retorno };
    }
}
